import  { useState, useEffect, useRef } from 'react'

import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'
import { Card, CardContent as CardBody, CardHeader} from '@shadcn/components/ui/card'
import { Collapsible, CollapsibleContent } from '@shadcn/components/ui/collapsible'

import Breadcrumbs from '../../components/Common/Breadcrumb';
import "./datatables.scss";

import useQuery from '../../helpers/JIFI/useQuery';
import ProductVariantSelector from './helpers/ProductVariantSelector.js';

import superagent from 'superagent'
import {backendUrl} from '../../helpers/consts.js'
import { toast, ToastContainer } from 'react-toastify';
import {
  describeAffectedReservation,
  describeImmovableReservation,
  prepareAlterStockRequest,
  prepareRemovalPreviewRequest,
  reservedRemovalPreviewFromError,
  takesReservedStock,
  withReservedRemovalAcknowledged,
} from './alter-stock-request';

import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@shadcn/components/ui/select';

import { Input } from '@shadcn/components/ui/input'
import { Button } from '@shadcn/components/ui/button'
import { Dialog } from '@radix-ui/react-dialog'
import { DialogContent, DialogFooter } from '@shadcn/components/ui/dialog'


const ProductRow = ({
  lineKey,
  item,
  products,
  editQuantityRow,
  editVariantRow,
  editProductRow,
  removeRow,
}) => {
  const setSelectedVariant = (variant) => {
    editProductRow(lineKey, variant?.product)
    editVariantRow(lineKey, variant?._id, variant?.sku, variant?.name)
  }

  return (
    <Row className="gap-6" style={{ padding: '12px 0' }}>
      <Col className="sm:w-8/12">
        <ProductVariantSelector
          products={products}
          setSelectedVariant={setSelectedVariant}
          selectedVariant={item}
          hidePersonalisationOptions
        />
      </Col>
      <Col className="sm:w-3/12">
        <Input
          className={`${item.quantity <= 0 ? 'border border-red-500 text-red-500' : ''}`}
          style={{ width: '90%' }}
          type="number"
          value={item.quantity}
          onChange={(event) => editQuantityRow(lineKey, event.target.value)}
        />
      </Col>
      <Col className="sm:w-1/12">
        <Button onClick={() => removeRow(lineKey)} variant="destructive">
          X
        </Button>
      </Col>
    </Row>
  )
}

const StockInput = ({stock, setStock, productData}) => {
  const handleAddRow = () => {
    setStock(prev => [...prev, {
      product: '',
      variant: '',
      name: '',
      sku: '',
      quantity: 0
    }])
  };

  const editProductRow = (id, productId) => {
    setStock(prev => {
      let newList = [...prev]
      newList[id]['product'] = productId
      return newList
    })
  };

  const editVariantRow = (id, val, sku, name) => {
    setStock(prev => {
      let newList = [...prev]
      newList[id]['variant'] = val
      newList[id]['quantity'] = 0
      newList[id]['sku'] = sku
      newList[id]['name'] = name
      return newList
    })
  };

  const editQuantityRow = (id, val) => {
    setStock(prev => {
      let newList = [...prev]
      newList[id]['quantity'] = parseInt(val)
      return newList
    })
  };

  const removeRow = (id) => {
    setStock(prev => {
      let newList = prev.filter((item, key) => key !== id)
      return newList
    })
    
  };

  const products = productData ? productData.map(product => {
    const variants = product.variants.map(variant => {
      return {
        _id: variant._id,
        name: variant.name,
        selected: stock.findIndex(val => val.variant === variant._id),
        sku: variant.sku,
        product: product._id
      }
    })

    return {
      name: product.name,
      _id: product._id,
      variants
    }
  }) : []

  return <>
    <Row>
      <Col className="sm:w-8/12">
        Variant
      </Col>
      <Col className="sm:w-4/12">
        Quantity
      </Col>
    </Row>
    <br/>
    {
      productData && stock.map((item, lineKey) => (
        <ProductRow
          key={lineKey}
          lineKey={lineKey}
          item={item}
          products={products}
          editQuantityRow={editQuantityRow}
          editVariantRow={editVariantRow}
          editProductRow={editProductRow}
          removeRow={removeRow}
        />
      ))
    }
    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
      <Button onClick={handleAddRow} variant="primary">
        Add{" "}
      </Button>{" "}
      <span />
    </div>
  </>
}


const PullPage =  () => {
  const user = JSON.parse(localStorage.getItem('authUser')) || {};
  const canAlterStock = user.permissions?.includes('AlterStockLevels');
  const [refresh, setRefresh] = useState(true)

  const [stockPush, setStockPush] = useState([])
  const [stockPull, setStockPull] = useState([])
  const [col1, setCol1] = useState(false)
  const [col2, setCol2] = useState(false)
  const [modal, setModal] = useState(false)
  const [stockType, setStockType] = useState('on_hand') 
  const [selectedLocation, setSelectedLocation] = useState('HQ2')

  const [loading, setlLoading] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const alterRequestRef = useRef(null)
  const [removalPreview, setRemovalPreview] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [previewError, setPreviewError] = useState('')

  // Which orders an on-hand pull would take reserved stock from, so the dialog
  // can warn before the pull is confirmed. It writes nothing.
  const loadRemovalPreview = async () => {
    setRemovalPreview(null)
    setPreviewError('')
    const request = prepareRemovalPreviewRequest({
      location: selectedLocation,
      pullStock: stockPull,
      stockType,
    })
    if (!request) return
    setPreviewLoading(true)
    try {
      const response = await superagent.post(`${backendUrl}/v2/allocation-planner/removal-preview`)
        .send(request)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
      setRemovalPreview(response.body)
    } catch (err) {
      const message = err?.response?.body?.message || err?.message || 'unknown error'
      setPreviewError(Array.isArray(message) ? message.join(', ') : message)
    } finally {
      setPreviewLoading(false)
    }
  }

  const togglemodal =  () => {
    setSubmitError('')
    if (!modal) loadRemovalPreview()
    setModal(prev => !prev)
  }

  const [data, state] = useQuery({
    url: `/product`,
    refresh
  });
  const productData = data && data.data

  const [locations] = useQuery({
    url: '/inventory/getAllLocationNames',
  });

  useEffect(() => {
    if (locations?.length > 0 && !locations.some(location => location.name === selectedLocation)) {
      setSelectedLocation(locations[0].name)
    }
  }, [locations, selectedLocation])

  const selectedLocationLabel = locations?.find(location => location.name === selectedLocation)?.display_name || selectedLocation


  const handleSubmit = async () => {
    setlLoading(true)
    setSubmitError('')
    const draft = {
      location: selectedLocation,
      pushStock: stockPush,
      pullStock: stockPull,
      stockType: stockType
    }
    const preparedRequest = prepareAlterStockRequest(draft, alterRequestRef.current)
    alterRequestRef.current = preparedRequest.requestState
    
    try {
      // The user has seen the preview in this dialog: confirming acknowledges the
      // reserved units it showed the pull taking.
      await superagent.post(`${backendUrl}/inventory/alter`)
        .send(withReservedRemovalAcknowledged(preparedRequest.payload, removalPreview))
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')

      setModal(false)
      alterRequestRef.current = null
      setRemovalPreview(null)
      setStockPull([])
      setStockPush([])
      toast.success('Stock updated successfully')
    } catch (err) {
      const message = err?.response?.body?.message || err?.message || 'Failed to update stock'
      // Stock changed since the preview (or it could not be read): show the
      // backend's, so the next confirm acknowledges what it shows.
      const refreshedPreview = reservedRemovalPreviewFromError(err?.response?.body)
      if (refreshedPreview) {
        setRemovalPreview(refreshedPreview)
        setPreviewError('')
      }
      setSubmitError(Array.isArray(message) ? message.join(', ') : message)
      toast.error(Array.isArray(message) ? message.join(', ') : message)
    } finally {
      setlLoading(false)
    }
  } 

  if (!canAlterStock) {
    return <div className="page-content">
      <div className="w-full px-3 mx-auto xl:max-w-[85%]">
        <Breadcrumbs title="Inventory" breadcrumbItem={'Alter Stock'} />
        <Card>
          <CardBody className='pt-6'>
            You do not have permission to alter stock.
          </CardBody>
        </Card>
      </div>
    </div>
  }

  return <div className="page-content">
    <ToastContainer position="top-right" autoClose={3000} />
    <div className="w-full px-3 mx-auto xl:max-w-[85%]">
      <Breadcrumbs title="Inventory" breadcrumbItem={'Alter Stock'} />
      <Row className="mb-2 gap-6">
        <Col  xs="12" m="8" lg="8" xl="8" className='sm:w-[60%]' >
          <Card>
            <CardBody className='pt-6'>
            
	             <div>
	              <p>Location:</p>
            <Select
              value={selectedLocation}
              onValueChange={setSelectedLocation}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select Location" />
              </SelectTrigger>
              <SelectContent>
                {locations?.length > 0 ? (
                  locations.map(location => (
                    <SelectItem key={location._id} value={location.name}>
                      {location.display_name || location.name}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="HQ2">HQ2</SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
          <br />
          <div>
            Stock Type:
            <Select
              defaultValue="on_hand"
              onValueChange={(value) => setStockType(value)} // Replace with your handler
            >
    <SelectTrigger>
      <SelectValue placeholder="Select Stock Type" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="on_hand">On Hand</SelectItem>
      <SelectItem value="dead">Dead</SelectItem>
      <SelectItem value="display">Display</SelectItem>
    </SelectContent>
  </Select>
</div>

              <br/><br/>
              <div id="accordion">
                  <Card className="mb-4">
                    <CardHeader className="p-3 bg-[#f6f6f6]" id="headingOne">
                      <h6 className="m-0 text-[14px] font-medium">
                        <span onClick={() => setCol1(prev => !prev)}
                          style={{ cursor: "pointer" }} className="text-dark">
                          Take stock <i className="bx bx-layer-minus text-danger ml-3" />
                        </span>
                      </h6>
                    </CardHeader>
                    <Collapsible  open={col1} onOpenChange={() => setCol1(prev => !prev)}>
                    <CollapsibleContent>
                      <Card>
                        <CardBody className='pt-6'>
                          <StockInput stock={stockPull} setStock={setStockPull} productData={productData} />
                        </CardBody>
                      </Card>
                      </CollapsibleContent>
                    </Collapsible>
                  </Card>
                  <Card className="mb-4">
                    <CardHeader className="p-3 bg-[#f6f6f6]" id="headingTwo">
                      <h6 className="m-0 text-[14px] font-medium">
                        <span  onClick={() => setCol2(prev => !prev)}
                          style={{ cursor: "pointer" }} className="text-dark">
                          Put stock back <i className="bx bx-add-to-queue text-success ml-3" />
                        </span>
                      </h6>
                    </CardHeader>
                    <Collapsible open={col2} onOpenChange={() => setCol2(prev => !prev)} >
                    <CollapsibleContent>
                      <Card>
                        <CardBody className='pt-6'>
                          <StockInput stock={stockPush} setStock={setStockPush} productData={productData} />
                        </CardBody>
                      </Card>
                      </CollapsibleContent>
                    </Collapsible>
                  </Card>
                </div>
              <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                <span />
                {(productData && (stockPull.length > 0 || stockPush.length > 0)) && (
                  <Button onClick={togglemodal} variant="primary" className="btn-lg btn-rounded">
                    Submit
                  </Button>
                ) }
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col className='sm:w-[30%]'>
          <Card>
            <CardBody className='pt-6'>
              <h4 className="card-title mb-4">STOCK SUMMARY</h4>
              <div className="mb-4 text-sm">Location: {selectedLocationLabel}</div>
              <br />
              {
                productData && stockPull.length > 0 && 'Removing:'
              }
              {
                productData && stockPull.map((line, lineKey) => {
                  return <div>  <span className="text-danger">-{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
                })
              }
              <br />
              {
                productData && stockPush.length > 0 && 'Adding:'
              }
              {
                productData && stockPush.map((line, lineKey) => {
                  return <div> <span className="text-success">+{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
                })
              }
            </CardBody>
          </Card> 
        </Col>
      </Row>
    </div>
    <Dialog open={modal} onOpenChange={togglemodal}>
     <DialogContent>
      <CardBody>
        <h4 className="card-title mb-4">STOCK SUMMARY</h4>
        <div className="mb-4 text-sm">Location: {selectedLocationLabel}</div>
        <br />
        {
          productData && stockPull.length > 0 && 'Removing:'
        }
        {
          productData && stockPull.map((line, lineKey) => {
            return <div>  <span className="text-danger">-{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
          })
        }
        <br />
        {
          productData && stockPush.length > 0 && 'Adding:'
        }
        {
          productData && stockPush.map((line, lineKey) => {
            return <div> <span className="text-success">+{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
          })
        }
        {previewLoading && <div className="mt-4 text-sm">Checking stock reserved for orders...</div>}
        {previewError && (
          <div className="mt-4 text-sm text-warning">Could not check stock reserved for orders: {previewError}</div>
        )}
        {removalPreview?.refused && (
          <div className="mt-4 text-danger">This will be refused: {removalPreview.refusedReason}</div>
        )}
        {removalPreview?.affected?.length > 0 && (
          <div className="mt-4">
            <div className="text-danger">
              {removalPreview.refused
                ? 'The stock is reserved for:'
                : `${removalPreview.affected.length} order line(s) will lose the stock reserved for them. `
                  + 'Allocation re-plans them straight away, lowest priority first:'}
            </div>
            <ul className="list-disc pl-5 text-sm">
              {removalPreview.affected.map(line => (
                <li key={line.lineItemId}>{describeAffectedReservation(line)}</li>
              ))}
            </ul>
          </div>
        )}
        {removalPreview?.immovable?.length > 0 && (
          <div className="mt-4">
            <div className="text-danger">
              Reserved for orders allocation cannot move to other stock, so it cannot be taken:
            </div>
            <ul className="list-disc pl-5 text-sm">
              {removalPreview.immovable.map(entry => (
                <li key={entry.sku}>{describeImmovableReservation(entry)}</li>
              ))}
            </ul>
          </div>
        )}
        {submitError && <div className="mt-4 text-danger">{submitError}</div>}
      </CardBody>
      <DialogFooter>
        {
          loading ? (
            <div className="spinner-border text-primary m-1" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <Button onClick={handleSubmit} variant="primary" className="btn-lg btn-rounded" disabled={previewLoading}>
              {takesReservedStock(removalPreview) && !removalPreview.refused ? 'Confirm anyway' : 'Confirm'}
            </Button>
          )
        }
      </DialogFooter>
      </DialogContent>
    </Dialog>
  </div>
}

export default PullPage
